import './requisition_role.css';
import { Component } from 'react';

import CandidatesList from '../components/CandidatesList';
import CandidatesListHeader from '../components/CandidatesList/CandidatesListHeader';
import CandidatesFilters from '../components/CandidatesList/CandidatesFilters';
import auth from '../utils/auth';
import { USStates } from '../utils/enums';
import {
  fetchCandidates,
  setSortFieldAndDirection,
  fetchCandidatesDebounced,
} from '../utils/candidatesSearchUtil';

import {
  fetchEmailTemplates,
  getInitialFilters,
  updateExperienceState,
  selectAll,
  clearAll,
  resetFilters,
} from '../utils/statusviewutils';
import { fetchDistrictTasks } from '../utils/universalTasksUtil';
import { retrieveUser } from '../utils/profileUtil';
import {
  deleteQueryStringValue,
  getQueryStringValue,
  setQueryStringValue,
  setQueryStringWithoutPageReload,
} from 'utils/util';
import { validateTagUserType } from '../components/CustomTag/util';

import categoriesAPI from 'api/categoriesAPI';
import customTagAPI from '../api/customTagAPI';
import districtAPI from '../api/districtAPI';
import RolesAPI from 'api/rolesAPI';
import schoolsAPI from 'api/schoolsAPI';
import schoolrolesAPI from 'api/schoolrolesAPI';

import grayArrow from '../assets/icon_right_caret_grey.svg';

import axios from 'axios';
import _ from 'lodash';

import { pushQueryLocation } from '../utils/routing';
import { withRouter } from 'react-router-dom';
import candidateAPI from 'api/candidateAPI';
import { DEBOUNCE_TYPING_TIMEOUT } from '../utils/constants';

class CandidatesListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      candidates: [],
      categories: [],
      credentialOptions: [],
      tags: [],
      query: '',
      counts: [],
      errors: {},
      page: 0,
      more: false,
      orderBy: getQueryStringValue('aci') === 't' ? 'nimble_score' : 'profile.updated',
      orderDir: 'desc',
      statusOptions: [],
      showSpinner: false,
      fetchCompleted: false, // use for loading message below CandidatesList
      fetchCandidatesCompleted: false, // use for loading message below CandidatesList
      fetchCandidatesRunning: false, // use to avoid calling before previous one finishes
      role: null,
      isRequisition: true,
      totalCandidateCount: 0,
      experienceStart: 0,
      experienceEnd: 30,
      status_list: [],
      job_status_list: [],
      internal_list: [],
      cred_list: [],
      job_subject_list: [],
      task_list: [],
      tag_ids: [],
      hrbp_assignees: [],
      hrbpAssigneeOptions: [],
      hellosign_templates: [],
      language_list: [],
      employment_type_and_hours: [],
      newApplicationStatuses: [],
      job_subject_length: 0,
      tag_ids_length: 0,
      hrbp_assignees_length: 0,
      districtRoleId: '',
      universal_tasks: [],
      visible_templates: [],
      partialApplication: {},
      application_type: 'application',
      partialUser: null,
      schoolAdminViewingDistrictApp: false,
      // candidate preference filters begin //
      multilingual_school: [],
      title_1_school: [],
      turnaround_school: [],
      grades: [],
      preference_categories: [],
      // candidate preference filters end //
      activeDistrictSchools: [],
      schoolPreferenceFilters: {
        isOpenToOtherOptions: true,
        selectedSchoolIds: [],
      },
      onboarding_locations: [],
      candidate_source_list: [],
      candidateSourceOptions: [],
      candidate_source_list_length: 0,
      all_sources: [],
    };
    this.isSchoolAdmin = auth.isSchoolAdmin();
    this.districtId = auth.getUser().profile.district.id;
    this.fetchEmailTemplates = fetchEmailTemplates.bind(this);
    this.setSortFieldAndDirection = setSortFieldAndDirection.bind(this);
    this.fetchCandidates = fetchCandidates.bind(this);
    this.fetchCandidatesDebounced = fetchCandidatesDebounced.bind(this);
    this.getInitialFilters = getInitialFilters.bind(this);
    this.updateExperienceState = updateExperienceState.bind(this);
    this.selectAll = selectAll.bind(this);
    this.clearAll = clearAll.bind(this);
    this.resetFilters = resetFilters.bind(this);
    this.retrieveUser = retrieveUser.bind(this);
    this.fetchDistrictTasks = fetchDistrictTasks.bind(this);
    this.district = auth.getUser().profile.district;
  }

  componentDidMount() {
    document.body.classList.add('candidates-list-page');
    document.body.classList.add('new-candidate-line-items');

    this.setDefaultSearchParams();
    this.setInitialFiltersThenSearch();
    this.fetchCredentialOptions();
    this.fetchCandidatesSources();

    this.setRoleOrSchoolRole();
    categoriesAPI.fetchCategories({ districtId: this.districtId }).then(this.setInitialCategories);
    this.fetchApplicationStatuses();
    this.setFilterStatuses();
    this.fetchDistrictTasks(true);
    this.fetchHellosignTemplates();
    schoolsAPI.fetchActiveSchools(this.districtId).then((activeDistrictSchools) => {
      this.setState({ activeDistrictSchools });
      this.setInitialSchoolPreferences(activeDistrictSchools);
      this.setInitialOnboardingLocations(activeDistrictSchools);
    });
    customTagAPI.fetchCustomTags().then((tags) => {
      const filteredTags = this.filteredDistrictTags(tags);
      this.setInitialCandidateTags(filteredTags);
    });
    // spec: "hrbp assignees" filter should include all district super/district admins
    if (auth.isDistrictAdmin(auth.getUser())) {
      districtAPI.getDistrictAndSuperAdmins(this.districtId).then(this.setInitialHrbpAssignees);
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('candidates-list-page');
    this.ignoreLastFetch = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.query !== this.state.query && this.state.query.length !== 1) {
      this.search();
    }
  }

  setDefaultSearchParams = () => {
    const defaultParams = auth.getUser().profile.view_by_posting_default_search_params;

    if (defaultParams) {
      if (!window.location.search) {
        // If there are no search params present, set the defaults
        setQueryStringWithoutPageReload('?' + defaultParams);
      } else {
        // If there are search params present, check whether they're the two
        // that are unrelated to list filtering which are "dr" (district
        // role) and "aci" (apply candidate insights). If those are the only
        // two search params, we still want to apply the default search
        // parameters.
        if (this.hasOnlyDrOrAciFilters()) {
          const searchParams = ['?'];
          if (getQueryStringValue('dr')) {
            searchParams.push(`dr=${getQueryStringValue('dr')}`);
          }
          if (getQueryStringValue('aci')) {
            searchParams.push(`aci=${getQueryStringValue('aci')}`);
          }
          searchParams.push(defaultParams);
          setQueryStringWithoutPageReload(searchParams.join('&'));
        }
      }
    }
  };

  hasOnlyDrOrAciFilters = () => {
    /** Return true if the current URL search has only the params "dr" or "aci".
     * If any other search params are present, return false. This function is
     * used to determine whether the user has other default filter params set.
     */
    const existingSearchParams = new URLSearchParams(window.location.search);
    const keys = Array.from(existingSearchParams.keys());

    let hasOtherFilters = false;
    keys.forEach((key) => {
      if (key !== 'dr' && key !== 'aci') {
        hasOtherFilters = true;
      }
    });

    return !hasOtherFilters;
  };

  setInitialFiltersThenSearch = () => {
    const { search } = this.props.location;
    const params = new URLSearchParams(search);
    const query = params.get('query');
    const districtRoleId = getQueryStringValue('dr');
    const daysAgo = params.get('days_ago');

    const {
      status_list,
      internal_list,
      cred_list,
      job_status_list,
      multilingual_school,
      title_1_school,
      turnaround_school,
      language_list,
      grades_list,
      preference_categories,
      employment_type_and_hours,
      experienceStart,
      experienceEnd,
      isOpenToOtherOptions,
      selectedSchoolIds,
      task_list,
      tag_ids,
      hrbp_assignees,
      hellosign_templates,
      job_subject_list,
      onboarding_locations,
      candidate_source_list,
    } = this.getInitialFilters(this.districtId);

    this.setState(
      {
        days_ago: daysAgo || '',
        query: query || '',
        roleId: this.props.match.params.id,
        districtRoleId,
        status_list,
        internal_list,
        cred_list,
        job_status_list,
        multilingual_school,
        title_1_school,
        turnaround_school,
        language_list,
        grades: grades_list,
        preference_categories,
        employment_type_and_hours,
        experienceStart,
        experienceEnd,
        schoolPreferenceFilters: {
          selectedSchoolIds,
          isOpenToOtherOptions,
        },
        task_list,
        hellosign_templates,
        job_subject_list,
        onboarding_locations,
        tag_ids,
        hrbp_assignees,
        candidate_source_list,
      },
      this.initialSearch
    );
  };

  startSpinner = () => {
    this.setState({ showSpinner: true });
  };

  stopSpinner = () => {
    this.setState({ showSpinner: false });
  };

  search = _.debounce((paginate = true) => {
    this.setState(
      {
        candidates: [],
        page: 0,
        more: false,
      },
      () => this.fetchCandidates(true, paginate, this.districtId)
    );
  }, DEBOUNCE_TYPING_TIMEOUT);

  initialSearch = (paginate = true) => {
    this.fetchCandidates(true, paginate, this.districtId);
  };

  fetchCandidatesSources = async () => {
    const params = { district_id: this.districtId, all_sources: true };
    candidateAPI.getCandidateSources(params).then((data) => {
      if (data) {
        data.unshift({ value: 'none', label: 'N/A' });

        const candidate_source_list = data.map((source) => source.value);

        this.setState(
          {
            candidateSourceOptions: candidate_source_list,
            sources: data,
          },
          this.setCandidateSourceOptions
        );
      }
    });
  };

  fetchApplicationStatuses = () => {
    axios.get(`/api/application_statuses/`).then((r) => {
      this.setState({ newApplicationStatuses: r.data });
    });
  };

  fetchCredentialOptions = () => {
    // eventually district state should be a foreign key to state model
    let stateObj = USStates().filter((state) => state.label === this.district.state)[0];
    axios.get(`/api/state/${stateObj.id}/`).then((r) => {
      let credentialResponse = r.data.credential_subjects.map((item) => {
        item['key'] = item.value;
        item['label'] = item.value;
        return item;
      });
      this.setState({ credentialOptions: credentialResponse }, this.state.setCredentialOptions);
    });
  };

  setCredentialOptions = () => {
    let credOptions = [...this.state.credentialOptions];

    // if there is no default candidate status filter, start with them all selected
    const f_C = getQueryStringValue('f_C');
    if (!f_C) this.setState({ cred_list: credOptions.map((s) => s.id) });

    this.setState({ credOptions });
  };

  setFilterStatuses = () => {
    const apiModule = this.isSchoolAdmin ? schoolrolesAPI : RolesAPI;
    apiModule.fetchFilterStatuses(this.props.match.params.id).then((statusOptions) => {
      this.setState({ statusOptions });

      // if there is no default candidate status filter, start with them all selected
      const f_CS = getQueryStringValue('f_CS');
      if (!f_CS) this.setState({ status_list: statusOptions.map((s) => s.id) });
    });
  };

  setCandidateSourceOptions = () => {
    let candidateSourceOptions = [...this.state.sources];
    const f_CSL = getQueryStringValue('f_CSL');
    if (!f_CSL)
      this.setState({
        candidate_source_list: candidateSourceOptions.map((source) => source.value),
        candidate_source_list_length: candidateSourceOptions.length,
      });

    this.setState({ candidateSourceOptions });
  };

  setInitialSchoolPreferences = (activeDistrictSchools) => {
    // if f_SS and f_O are both in the query string on mount
    // they have defaults set so don't overwrite them.
    const f_SS = getQueryStringValue('f_SS');
    const f_O = getQueryStringValue('f_O');

    // f_SS has to be compared to null because it can be an empty string,
    // in which case we don't want to overwrite it because the selectedSchoolIds
    // field should be empty.
    if (f_SS !== null && f_O) {
      return;
    }

    const activeSchoolIds = activeDistrictSchools.map((school) => school.id);

    this.setState((prevState) => {
      const newFilters = { ...prevState.schoolPreferenceFilters };
      // only update initial filter if a default is not set
      if (f_SS === null) newFilters.selectedSchoolIds = activeSchoolIds;
      if (!f_O) newFilters.isOpenToOtherOptions = true;
      return { schoolPreferenceFilters: newFilters };
    });
  };

  setInitialOnboardingLocations = (activeDistrictSchools) => {
    // if f_OL is in the query string on mount it has a
    // default set so don't overwrite.
    const f_OL = getQueryStringValue('f_OL');
    if (!f_OL) {
      const activeSchoolIds = activeDistrictSchools.map((school) => school.id);
      this.setState({ onboarding_locations: activeSchoolIds });
    }
  };

  setRoleOrSchoolRole = () => {
    if (this.isSchoolAdmin) {
      schoolrolesAPI
        .fetchSchoolRole(this.props.match.params.id)
        .then((role) => this.setState({ role }));
    } else {
      RolesAPI.fetchRole(this.props.match.params.id).then((role) => this.setState({ role }));
    }
  };

  setCurrentQuery = (newQuery, search) => {
    /** @param {boolean} search: true or undefined (not provided). If true, explicitly run this.search
     * because the query string may not have been updated.
     */
    this.setState(newQuery);

    const {
      history,
      location: { pathname, search: previousSearch },
    } = this.props;

    pushQueryLocation(newQuery, search, history, pathname, previousSearch, this.search);
  };

  updateMultiSelectFilter = (fieldName, fieldValue, active, optionsLength) => {
    /** this.state[fieldName] should always be an array. If active is true,
     * the filter option that was clicked is active and should be turned off, which means we
     * have to remove fieldValue from the array instead of adding it.
     */
    let updatedField;
    if (active) {
      // filter is active and the user wants to turn it off. Find the element and remove.
      updatedField = this.state[fieldName].filter((e) => e !== fieldValue);
    } else {
      updatedField = this.state[fieldName];
      updatedField.push(fieldValue);
    }

    if (updatedField.length === 0 || updatedField.length === optionsLength) {
      deleteQueryStringValue(fieldName);
    } else {
      setQueryStringValue(fieldName, updatedField.join());
    }
    this.setState({ [fieldName]: updatedField }, this.search);
  };

  updateMultiSelectFilterWithMultipleValues = (fieldName, values, optionsLength) => {
    /** Similar to this.updateMultiSelectFilter, but set multiple
     * values using an array instead of updating a single value.
     * The array can be empty.
     */
    if (values.length === 0 || values.length === optionsLength) {
      deleteQueryStringValue(fieldName);
    } else {
      setQueryStringValue(fieldName, values.join());
    }
    this.setState({ [fieldName]: values }, this.search);
  };

  setApplicationForQuickView = (partialApplication, partialUser) => {
    let application_type =
      partialApplication.role && partialApplication.role.district_role
        ? 'schoolapplication'
        : 'application';
    this.setState({
      partialUser,
      partialApplication,
      application_type,
    });
  };

  updateCandidateInState = (updatedCandidate) => {
    // Because we're on view by posting, filter applications to those related for this role
    let [applicationsForRole, schoolapplicationsForRole] = this.getAppsForRole(updatedCandidate);

    updatedCandidate = {
      ...updatedCandidate,
      applications: applicationsForRole,
      schoolapplications: schoolapplicationsForRole,
    };

    this.setState((prevState) => {
      return {
        candidates: prevState.candidates.map((candidate) =>
          candidate.id === updatedCandidate.id ? { ...candidate, ...updatedCandidate } : candidate
        ),
      };
    });
  };

  refreshCandidateInList = (candidateId) => {
    const params = {
      job_status_list: this.state.job_status_list,
      role_id: this.props.match.params.id,
    };
    axios
      .get(`/api/user/${candidateId}/candidates_list_data/`, { params })
      .then(({ data }) => this.updateCandidateInState(data));
  };

  updateCandidatesInContainerState = (updatedCandidates) => {
    this.setState((prevState) => {
      const candidates = prevState.candidates.map((candidate) => {
        let updatedCandidate = updatedCandidates.find((c) => c.id === candidate.id);
        return updatedCandidate ? { ...candidate, ...updatedCandidate } : candidate;
      });
      return { candidates };
    });
  };

  getAppsForRole = (updatedCandidate) => {
    let applicationsForRole;
    let schoolapplicationsForRole;

    if (auth.isDistrictUser()) {
      applicationsForRole = updatedCandidate.applications.filter(
        (app) => app.role.id === this.state.role.id
      );
      // district users and above don't need schoolapps in container state
      schoolapplicationsForRole = [];
    } else {
      applicationsForRole = updatedCandidate.applications.filter(
        (app) => app.role.id === this.state.role.district_role.id
      );
      schoolapplicationsForRole = updatedCandidate.schoolapplications.filter(
        (schoolapp) => schoolapp.role.id === this.state.role.id
      );
    }

    return [applicationsForRole, schoolapplicationsForRole];
  };

  selectAllSchoolPreferencesFilters = () => {
    // selecting all deactivates the filter, so remove search params
    deleteQueryStringValue('selectedSchoolIds');
    deleteQueryStringValue('isOpenToOtherOptions');

    this.setState(
      {
        schoolPreferenceFilters: {
          isOpenToOtherOptions: true,
          selectedSchoolIds: this.state.activeDistrictSchools.map((school) => school.id),
        },
      },
      this.search
    );
  };

  clearAllSchoolPreferencesFilters = () => {
    deleteQueryStringValue('selectedSchoolIds');
    deleteQueryStringValue('isOpenToOtherOptions');

    this.setState(
      {
        schoolPreferenceFilters: {
          isOpenToOtherOptions: false,
          selectedSchoolIds: [],
        },
      },
      this.search
    );
  };

  updateSelectedSchoolIds = (schoolId) => {
    this.setState((prevState) => {
      let selectedSchoolIds = prevState.schoolPreferenceFilters.selectedSchoolIds;
      if (selectedSchoolIds.includes(schoolId)) {
        selectedSchoolIds = selectedSchoolIds.filter((id) => id !== schoolId);
      } else {
        selectedSchoolIds = [...selectedSchoolIds, schoolId];
      }

      this.handleSchoolPreferencesQueryString(
        selectedSchoolIds,
        prevState.schoolPreferenceFilters.isOpenToOtherOptions
      );

      return {
        schoolPreferenceFilters: {
          ...prevState.schoolPreferenceFilters,
          selectedSchoolIds,
        },
      };
    }, this.search);
  };

  updateIsOpenToOtherOptions = () => {
    this.setState((prevState) => {
      // this is what we're actually toggling, but we need the currentSchools value
      // in order to determine whether the filter is active or not
      const isOpenToOtherOptions = !prevState.schoolPreferenceFilters.isOpenToOtherOptions;

      this.handleSchoolPreferencesQueryString(
        prevState.schoolPreferenceFilters.selectedSchoolIds,
        isOpenToOtherOptions
      );

      return {
        schoolPreferenceFilters: {
          ...prevState.schoolPreferenceFilters,
          isOpenToOtherOptions,
        },
      };
    }, this.search);
  };

  handleSchoolPreferencesQueryString = (selectedSchoolIds, isOpenToOtherOptions) => {
    const noneSelected = selectedSchoolIds.length === 0 && !isOpenToOtherOptions;
    const allSelected =
      selectedSchoolIds.length === this.state.activeDistrictSchools.length && isOpenToOtherOptions;

    if (noneSelected || allSelected) {
      deleteQueryStringValue('isOpenToOtherOptions');
      deleteQueryStringValue('selectedSchoolIds');
    } else {
      setQueryStringValue('isOpenToOtherOptions', isOpenToOtherOptions.toString());
      setQueryStringValue('selectedSchoolIds', selectedSchoolIds.join(','));
    }
  };

  fetchHellosignTemplates = () => {
    axios.get('/api/hellosign/visible_templates/').then(({ data }) => {
      const visible_templates = data;
      this.setState({ visible_templates });

      const f_HT = getQueryStringValue('f_HT');

      if (!f_HT) {
        let hellosign_templates = [];

        visible_templates.forEach(({ template_id }) => {
          hellosign_templates.push(template_id);
          hellosign_templates.push(`-${template_id}`);
        });

        this.setState({ hellosign_templates });
      }
    });
  };

  setInitialCategories = (categories) => {
    let job_subject_list = [];
    categories.forEach((c) => {
      c.subcategories.forEach((s) => {
        job_subject_list.push(Number(s.id));
      });
    });

    this.setState({
      categories,
      job_subject_length: job_subject_list.length,
    });

    // only set job subjects if there is no default filter set
    const f_JSU = getQueryStringValue('f_JSU');
    if (!f_JSU) {
      this.setState({ job_subject_list });
    }
  };

  setInitialCandidateTags = (tags) => {
    const tag_ids = tags.map((tag) => Number(tag.id));

    // add full tag data to state
    this.setState({
      tags,
      tag_ids_length: tag_ids.length,
    });

    // only set tags if there is no default filter set
    const f_TG = getQueryStringValue('f_TG');
    if (!f_TG) {
      this.setState({
        tag_ids,
      });
    }
  };

  setInitialHrbpAssignees = (hrbpAssigneesData) => {
    const hrbp_assignees = hrbpAssigneesData.map((assignee) => assignee.id);

    // add full admin user data to state
    this.setState({
      hrbpAssigneeOptions: hrbpAssigneesData.map((assignee) => ({
        value: assignee.id,
        label: assignee.name,
      })),
      hrbp_assignees_length: hrbpAssigneesData.length,
    });

    // only set users if there is no default filter set
    const f_HA = getQueryStringValue('f_HA');
    if (!f_HA) {
      this.setState({
        hrbp_assignees,
      });
    }
  };

  // user should only see candidate tags related to their user_type
  filteredDistrictTags = (tag_ids) => {
    const filteredTags = tag_ids.filter((tag) => {
      // exclude prospect only tag types (but include hybrid tags that apply to both)
      if (!tag.candidate_type && tag.prospect_type) return false;

      // tag is not meant for current user
      if (!validateTagUserType(auth.getUser(), tag)) return false;

      // tag is valid
      return tag;
    });
    return filteredTags;
  };

  incrementNoteCount = (candidateId) => {
    const candidates = [...this.state.candidates];
    const candidate = candidates.find((c) => c.id === candidateId);
    candidate.note_count += 1;
    this.setState({ candidates });
  };

  incrementScorecardCount = (candidateId, diff) => {
    const candidates = [...this.state.candidates];
    const candidate = candidates.find((c) => c.id === candidateId);
    candidate.scorecard_count += diff;
    this.setState({ candidates });
  };

  render() {
    const routeType = this.isSchoolAdmin ? 'school' : 'district';
    const { search } = this.props.location;
    const searchParams = new URLSearchParams(search);
    const query = searchParams.get('query');
    const daysAgo = searchParams.get('days_ago');

    return (
      <div className="candidateslist-and-filter-container requisition-role">
        <CandidatesFilters
          statusOptions={this.state.statusOptions}
          experienceStart={this.state.experienceStart}
          experienceEnd={this.state.experienceEnd}
          updateMultiSelectFilter={this.updateMultiSelectFilter}
          updateMultiSelectFilterWithMultipleValues={this.updateMultiSelectFilterWithMultipleValues}
          status_list={this.state.status_list}
          job_status_list={this.state.job_status_list}
          internal_list={this.state.internal_list}
          cred_list={this.state.cred_list}
          job_subject_list={this.state.job_subject_list}
          task_list={this.state.task_list}
          tag_ids={this.state.tag_ids}
          hrbp_assignees={this.state.hrbp_assignees}
          hrbpAssigneeOptions={this.state.hrbpAssigneeOptions}
          hellosign_templates={this.state.hellosign_templates}
          language_list={this.state.language_list}
          employment_type_and_hours={this.state.employment_type_and_hours}
          categories={this.state.categories}
          tags={this.state.tags}
          newApplicationStatuses={this.state.newApplicationStatuses}
          updateExperienceState={this.updateExperienceState}
          selectAll={this.selectAll}
          clearAll={this.clearAll}
          universal_tasks={this.state.universal_tasks}
          visible_templates={this.state.visible_templates}
          multilingual_school={this.state.multilingual_school}
          title_1_school={this.state.title_1_school}
          turnaround_school={this.state.turnaround_school}
          grades={this.state.grades}
          preference_categories={this.state.preference_categories}
          onboarding_locations={this.state.onboarding_locations}
          activeDistrictSchools={this.state.activeDistrictSchools}
          schoolPreferenceFilters={this.state.schoolPreferenceFilters}
          selectAllSchoolPreferencesFilters={this.selectAllSchoolPreferencesFilters}
          clearAllSchoolPreferencesFilters={this.clearAllSchoolPreferencesFilters}
          updateSelectedSchoolIds={this.updateSelectedSchoolIds}
          updateIsOpenToOtherOptions={this.updateIsOpenToOtherOptions}
          credentialOptions={this.state.credentialOptions}
          candidate_source_list={this.state.candidate_source_list}
          candidateSourceOptions={this.state.candidateSourceOptions}
          all_sources={this.state.sources}
        />
        <div className="candidateslist-container" style={{ paddingTop: '20px' }}>
          <div className="header-section requisition-role-header-section">
            <div className="job-title">
              <span>
                <a href={`/${routeType}/requisition-roles`}>
                  <img src={grayArrow} alt="left arrow" />
                  {this.state.role?.title ?? ''}
                </a>
              </span>
            </div>
            <CandidatesListHeader
              daysAgo={daysAgo}
              query={this.state.query}
              setCurrentQuery={this.setCurrentQuery}
              totalCandidateCount={this.state.totalCandidateCount}
              showSpinner={this.state.showSpinner}
              onProspectList={false}
              onViewByPosting={true}
              resetFilters={this.resetFilters}
              defaultSort="nimble_score"
              defaultOrder="desc"
            />
          </div>
          <CandidatesList
            candidates={this.state.candidates}
            hasMore={this.state.more}
            fetchCandidates={this.fetchCandidates}
            fetchCandidatesDebounced={this.fetchCandidatesDebounced}
            search={this.search}
            isRequisition={this.state.isRequisition}
            toggleShowingApplications={this.toggleShowingApplications}
            viewByPostingRoleId={parseInt(this.state.roleId, 10)}
            totalCandidateCount={this.state.totalCandidateCount}
            orderBy={this.state.orderBy}
            orderDir={this.state.orderDir}
            setSortFieldAndDirection={this.setSortFieldAndDirection}
            jobTitle={this.state.role?.title ?? ''}
            role={this.state.role}
            newApplicationStatuses={this.state.newApplicationStatuses}
            statusOptions={this.state.statusOptions}
            onProspectList={false}
            onViewByPosting={true}
            districtRoleId={this.state.districtRoleId}
            retrieveUser={this.retrieveUser}
            partialApplication={this.state.partialApplication}
            application_type={this.state.application_type}
            setApplicationForQuickView={this.setApplicationForQuickView}
            partialUser={this.state.partialUser}
            job_status_list={this.state.job_status_list}
            fetchCandidatesRunning={this.state.fetchCandidatesRunning}
            refreshCandidateInList={this.refreshCandidateInList}
            updateCandidatesInContainerState={this.updateCandidatesInContainerState}
            showSpinner={this.state.showSpinner}
            incrementNoteCount={this.incrementNoteCount}
            incrementScorecardCount={this.incrementScorecardCount}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(CandidatesListContainer);
